import PropTypes from 'prop-types';
import React, {Component} from 'react';
import times from 'lodash/times';
import flatten from 'lodash/flatten';
import cN from 'classnames';

import {hyphenize} from '../../../utils/text';

const point = ({x, y}) => `${x},${y}`;

const Triangle = ({a, b, c}) => (
    <polygon
        points={`${point(a)} ${point(b)} ${point(c)}`}
        style={{fill: 'black'}}
    />
);

const Line = props => (
    <line {...props} style={{stroke: 'black', strokeWidth: '0.5'}} />
);

const Label = ({children, fontSize, ...props}) => (
    children && (
        <foreignObject overflow="visible" {...props}>
            <div style={{height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                <p style={{textAlign: 'center', wordWrap: 'break-word', hyphens: 'manual', fontSize}}>
                    {hyphenize(children)}
                </p>
            </div>
        </foreignObject>
    )
);

Label.propTypes = {
    children: PropTypes.string,
    fontSize: PropTypes.string,
};

Label.defaultProps = {
    children: '',
    fontSize: '0.4em',
};

const TRIANGLE_DATA = [
    {a: {x: 45, y: 9}, b: {x: 55, y: 9}, c: {x: 50, y: 4}}, // TOP
    {a: {x: 9, y: 45}, b: {x: 9, y: 55}, c: {x: 4, y: 50}}, // LEFT
    {a: {x: 91, y: 45}, b: {x: 91, y: 55}, c: {x: 96, y: 50}}, // BOTTOM
    {a: {x: 45, y: 91}, b: {x: 55, y: 91}, c: {x: 50, y: 96}}, // RIGHT
];

const MatrixBoxes = ({selected, onClick, showLines, ...props}) => (
    <svg {...props} viewBox="0 0 100 100">
        {TRIANGLE_DATA.map((data, index) => <Triangle key={index} {...data} />)}

        {showLines && (
            <g>
                <Line x1="9" y1="9" x2="7" y2="7" />
                <Line x1="91" y1="9" x2="93" y2="7" />
                <Line x1="9" y1="91" x2="7" y2="93" />
                <Line x1="91" y1="91" x2="93" y2="93" />
            </g>
        )}
        <svg x="10" y="10" width="80" height="80" viewBox="0 0 90 90">
            {flatten(
                times(9, row =>
                    times(9, col => (
                        <rect
                            key={`${row}-${col}`}
                            width="10"
                            height="10"
                            x={10 * row}
                            y={10 * col}
                            className={
                                (selected.x === (-4 + row) && selected.y === (-4 + col)) ? 'selected' : 'unselected'
                            }
                            onClick={() => onClick(-4 + row, -4 + col)}
                        />
                    )),
                ),
            )}
        </svg>
    </svg>
);


class Matrix extends Component {

    static propTypes = {
        config: PropTypes.shape({
            labelLeft: PropTypes.string.isRequired,
            labelRight: PropTypes.string.isRequired,
            labelTop: PropTypes.string.isRequired,
            labelBottom: PropTypes.string.isRequired,
            labelTopLeft: PropTypes.string,
            labelTopRight: PropTypes.string,
            labelBottomLeft: PropTypes.string,
            labelBottomRight: PropTypes.string,
        }).isRequired,
        answer: PropTypes.shape({
            x: PropTypes.number,
            y: PropTypes.number,
        }).isRequired,
        updateAnswer: PropTypes.func.isRequired,
    };

    static canContinue(answer, config) {
        const {answer_optional: isAnswerOptional} = config;
        if (isAnswerOptional) {
            return false;
        }

        return !Boolean(answer && typeof answer.x === 'number' && typeof answer.y === 'number');
    }

    render() {
        const {config = {}, answer, missingInfo} = this.props;
        const {
            labelTop, labelLeft, labelRight, labelBottom,
            labelTopLeft, labelTopRight, labelBottomLeft, labelBottomRight,
        } = config;
        const {x = 0, y = 0} = answer;
        
        return (
            <div className={cN('matrix-block', {missing: missingInfo})}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 150" preserveAspectRatio="xMidYMid meet" overflow="visible">
                    <MatrixBoxes
                        x="50"
                        y="20"
                        width="100"
                        height="100"
                        selected={{x, y}}
                        onClick={this.onClick}
                        showLines={labelTopLeft || labelTopRight || labelBottomLeft || labelBottomRight}
                    />

                    <Label x="60" y="0" width="80" height="20">{labelTop}</Label>
                    <Label x="0" y="20" width="50" height="100">{labelLeft}</Label>
                    <Label x="60" y="120" width="80" height="20">{labelBottom}</Label>
                    <Label x="150" y="20" width="50" height="100">{labelRight}</Label>

                    <Label x="0" y="10" width="60" height="20" fontSize="0.3em">{labelTopLeft}</Label>
                    <Label x="140" y="10" width="60" height="20" fontSize="0.3em">{labelTopRight}</Label>
                    <Label x="0" y="110" width="60" height="20" fontSize="0.3em">{labelBottomLeft}</Label>
                    <Label x="140" y="110" width="60" height="20" fontSize="0.3em">{labelBottomRight}</Label>
                </svg>
            </div>
        );
    }

    onClick = (x, y) => this.props.updateAnswer({x, y})

}

export default Matrix;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/Matrix.js